import React from 'react';
import { browserHistory } from 'react-router';
import { Button, Col, Row } from 'react-bootstrap';
import HeaderFilters from './HeaderFilters';
import { GFTeacherUser } from '../../models/models';

type Props = {
  teacher: GFTeacherUser|undefined;
}

const Header: React.FC<Props> = ({ teacher }) => (
  <Row className="students-header">
    <Col md={10} xs={10} className="text-xl-left">
      <h1 className="pageDescription">
        Performance Metrics
        {! teacher && <Button
          onClick={() => browserHistory.push('/classprogress')}
          bsStyle="primary"
          type="button"
          bsSize="sm"
        >
          Class Progress Report
        </Button>}
        {!! teacher && <Button
          onClick={() => browserHistory.push('/teachers')}
          bsStyle="primary"
          type="button"
          bsSize="sm"
        >
          Manage Teachers
        </Button>}
      </h1>
      {!! teacher && <HeaderFilters teacher={teacher}/>}
    </Col>
  </Row>
);

export default Header;
